import React from 'react'
// libs
import { useSelector } from 'react-redux'
// components
import AddItemButton from '../../../AddItemButton'
import ControlButtons from '../ControlButtons'
// view
import { WidgetContainer } from 'components/PageComponents/Home/components/DashboardWidgets/views'
import { SectionTitle, SectionWrapper, WidgetsContainer } from './views'
// store
import { currentDashboardSelector, isDashboardEditSelector, Widget } from 'store/reducers/dashboards'
// utils
import { getWidgetContent } from '../../index'

interface Props {
  data: Widget
}

const Section: React.FC<Props> = ({ data }) => {
  const isEdit = useSelector(isDashboardEditSelector)
  const currentDashboard = useSelector(currentDashboardSelector)

  const { padding, dropShadow, transparency, showTitle, title } = data.item.settings

  const widgets = currentDashboard?.widgets?.filter(widget => widget.item.parentDashboardItemId === data.item.id) || []

  return (
    <SectionWrapper padding={padding} dropShadow={dropShadow} transparency={transparency}>
      {(isEdit || showTitle) && <SectionTitle padding={padding}>{showTitle ? title : ''}</SectionTitle>}
      <WidgetsContainer>
        {widgets.map(widget => (
          <WidgetContainer key={widget.item.id} width={widget.item.settings.width}>
            {getWidgetContent(widget)}
            <ControlButtons widget={widget} />
          </WidgetContainer>
        ))}
      </WidgetsContainer>
      {isEdit && <AddItemButton parentWidget={data} />}
    </SectionWrapper>
  )
}

export default Section
